<template>
    <div class="saveUpdate">
        <el-dialog :close-on-click-modal="false" title="转账" :visible.sync="showDialog" @close="$emit('update:showTransfre', false)"
                   :showTransfre="showTransfre" width="500px">
            <el-form :model="DetailInfo" ref="saveChn" label-width="130px" size="mini">
                <dialog-wrapper :MaxWidth="400">
                    <el-form-item label="游戏平台：">
                        <el-input v-model.number="DetailInfo.mch_id"  placeholder="请选择"></el-input>
                    </el-form-item>
                    <el-form-item label="充值金额：">
                        <el-input v-model.number="DetailInfo.receipt_address_id" ></el-input>
                    </el-form-item>
                    <el-form-item label="玩家ID：">
                        <el-input v-model="DetailInfo.user_id"></el-input>
                    </el-form-item>
                    <el-form-item label="金额：">
                        <el-input v-model.number="DetailInfo.amount" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="DetailInfo.remark"></el-input>
                    </el-form-item>
                </dialog-wrapper>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="$emit('update:showTransfre', false)" size="small">取 消</el-button>
                <el-button type="primary" :loading="loading" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import DialogWrapper from '@/components/DialogWrapper'
    export default {
        components: { DialogWrapper },
        data() {
            return {
                setbank: false,
                showDialog: this.showTransfre,
                loading: false,
                DetailInfo: {}
            }
        },
        props: {
            showTransfre: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number
            },
            AgencyType: {
                type: Object
            },
            settleCycle: {
                type: Object
            },
            MerchantsList: {
                type: Array
            },
        },
        methods: {

        },
        watch: {
            showTransfre() {
                this.showDialog = this.showTransfre
            }
        }
    }
</script>